// extracted by mini-css-extract-plugin
module.exports = {"container":"BDPRenameModal_container__3ohbi"};